import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { FiMenu, FiX, FiFileText, FiHome } from 'react-icons/fi';

const HeaderNavbar = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <nav className={`navbar ${isScrolled ? 'scrolled' : ''}`}>
      <div className="navbar-container">
        <Link to="/" className="navbar-brand">
          <div className="brand-icon">CV</div>
          <div className="brand-text">
            <span className="brand-title">Free ATS Resume</span>
            <span className="brand-subtitle">Editorial Edition</span>
          </div>
        </Link>

        <button 
          className="mobile-menu-toggle"
          onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
          aria-label="Toggle menu"
        >
          {isMobileMenuOpen ? <FiX /> : <FiMenu />}
        </button>

        <div className={`navbar-links ${isMobileMenuOpen ? 'open' : ''}`}>
          <Link 
            to="/" 
            className={`nav-link ${location.pathname === '/' ? 'active' : ''}`}
            onClick={() => setIsMobileMenuOpen(false)}
          >
            <FiHome />
            <span>Home</span>
          </Link>
          <Link 
            to="/create-resume" 
            className={`nav-link ${location.pathname === '/create-resume' ? 'active' : ''}`}
            onClick={() => setIsMobileMenuOpen(false)}
          >
            <FiFileText />
            <span>Create Resume</span>
          </Link>
          <div className="nav-accent"></div>
        </div>
      </div>
    </nav>
  );
};

export default HeaderNavbar;